import { useTranslation } from 'react-i18next'

import { FormInputsType } from '@pages/FormCreateOrEdit/types'

import { GENERATOR_INPUT_TYPE } from '@constants'

import { useHandlers } from './useHandlers'

type UseObjectYInputsType = ReturnType<typeof useHandlers>

export const useObjectYInputs = (props: UseObjectYInputsType) => {
  const { data, state, handlers } = props

  const { t } = useTranslation()

  const { watchObjectYObject } = state
  const {
    objectsOptions,
    objectYSelectedObjectFieldsOptions,
    objectYSelectedObjectCommandsOptions,
  } = data
  const { handleChangeObjectYObject, handleChangeObjectYCommand } = handlers

  const objectYInputs: FormInputsType[] = [
    {
      name: 'objectY.object',
      autocompleteOptions: objectsOptions,
      inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
      onChangeAutocomplete: handleChangeObjectYObject,
      rules: {
        required: true,
      },
      label: t('timeLinesCreateOrEdit.objectY.object'),
      placeholder: t('timeLinesCreateOrEdit.objectY.chooseObject'),
    },
    ...(watchObjectYObject?.id
      ? [
          {
            name: 'objectY.keyField',
            autocompleteOptions: objectYSelectedObjectFieldsOptions,
            inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
            rules: {
              required: true,
            },
            label: t('timeLinesCreateOrEdit.objectY.keyField'),
            placeholder: t('timeLinesCreateOrEdit.objectY.keyField'),
          },
          {
            name: 'objectY.getDataCommand.name',
            autocompleteOptions: objectYSelectedObjectCommandsOptions,
            inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
            rules: {
              required: true,
            },
            label: t('timeLinesCreateOrEdit.objectY.command'),
            placeholder: t('timeLinesCreateOrEdit.objectY.command'),
            onChangeAutocomplete: handleChangeObjectYCommand,
          },
        ]
      : []),
  ]

  return {
    objectYInputs,
  }
}
